module.exports = __webpack_public_path__ + "img/Quite.71484dfe.jpg";